import { APExpanded, APColumn } from "ap-components";
import { RouteComponentProps, Router } from "@gatsbyjs/reach-router";
import ClientOnboardingPage from "./ClientOnboardingPage";
import ClientApprovalPage from "./ClientApprovalPage";

export default function ClientOnboardingRoutes(_props: RouteComponentProps) {
    return (
        <APExpanded>
            <APColumn mainAxisSize="max" style={{ height: "100svh", backgroundColor: "#f2f5f8" }}>
                {/* AssetPlus branded header */}
                <div style={{
                    width: "100%",
                    height: "56px",
                    flexShrink: 0,
                    backgroundColor: "#1b3e78",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "8px 16px",
                }}>
                    <img
                        src="/Assetplus_Partner.svg"
                        alt="AssetPlus"
                        style={{ height: "18px" }}
                    />
                </div>

                <Router style={{
                    flex: 1,
                    display: "flex",
                    backgroundColor: "#f2f5f8",
                    overflowY: "auto",
                }}>
                    <ClientOnboardingPage path="/" default />
                    <ClientApprovalPage path="approval" />
                </Router>
            </APColumn>
        </APExpanded>
    );
}
